// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7fe9d27","732":"385a10b4","977":"786ebb9f"}[chunkId] + ".chunk.js";
};